import { ISSOToken } from "dataModels/ooauth2";
import { getUserData } from "net/ooAuth2";
import { APP_USER_PROFILES, AppUserRole, IAppUserProfile } from "shared/constants";

interface IUserData{
    userId:number,
    rid:string,
    surname:string,
    name:string,
    email:string,
    isActive:boolean,
    roles:AppUserRole[],
    plants:number[],
    customers:number[], 
    carriers:number[] 
}

export class AppUser{
    isAuthenticated:boolean;
    private _userData:IUserData|undefined;
    private _userProfile:IAppUserProfile|undefined;

    constructor(){
        this.isAuthenticated = false;
        this._userProfile = undefined;
    }
    public setData(data:IUserData){
        this._userData = data;
        this.isAuthenticated = true;
    }
    public set userPofile(profile:IAppUserProfile){
        this._userProfile = profile;
    }
    public get userProfile(){
        return this._userProfile;
    }
    public getFullName(){
        return this._userData?.surname+" "+this._userData?.name;
    }
    public getEmail(){
        return this._userData?.email
    }
    public getID(){
        return this._userData?.userId;
    }
    public getRid(){
        return this._userData?.rid;
    }
    public getFirstName(){
        return this._userData?.name;
    }
    public getLastName(){
        return this._userData?.surname;
    }
    public getRoles(){
        return this._userData?.roles;
    }
    public getRole(){
        return this._userData?.roles[0];
    }
    public getPlants(){
        return this._userData?.plants;
    }
    public getCustomers(){
        return this._userData?.customers;
    }
    public getCarriers(){
        return this._userData?.carriers;
    }
}